import { useEffect } from 'react';
import { useTradingTheme } from '@trading-ui/core';
import { ThemeUtils } from '../../utils/theme.utils';

export default function ThemeCSSGenerator() {
  const theme = useTradingTheme();

  useEffect(() => {
    ThemeUtils.generateCSSFromTheme(theme);
    document.getElementById('root')?.setAttribute('data-theme', theme.palette.mode);
  }, [theme]);

  return null;
}
